const AccountInfo = {
	data() {
		return {
			accountId: '',
		}
	},
	computed: {
		account() {
			// Return the logged account info
			return this.$store.getters.loggedAccount
		},
		isLoggedIn() {
			// Return if account is logged in
			return this.$store.getters.loggedIn
		},
		isCompletedAccount() {
			return this.$store.getters.loggedAccount.completed
		},
		isUserAccount() {
			// Return if logged account is user or not
			return this.$store.getters.isUser
		},
	},
	mounted() {
		this.accountId = this.account !== null ? this.account.id : null
	},
}

export default AccountInfo



// WEBPACK FOOTER //
// ./src/mixins/AccountInfo.js